<template>
  <v-card style="height:100%">
    <v-card-title class="data-table-header">
      <v-row no-gutters v-if="table_only === undefined || table_only === false">
        <v-row style="height: fit-content;" class="align-center d-flex flex-row" no-gutters> <v-col :lg="3">
            <v-text-field v-model="search"  @input="handleInput" append-icon="search" label="Search" placeholder="Search" hide-details outlined
              dense></v-text-field>
          </v-col>

          <!-- <div style="padding: 12px;"><v-btn color="green" elevation="0" text depressed><v-icon color="#808080">{{
            "mdi-filter-variant" }}</v-icon></v-btn></div> -->

            <v-menu v-if="(entity_name == 'wayBill' || entity_name == 'pending_wayBill') && showCardView == true"  style="background: white; " ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on">
                <v-icon>{{'mdi-filter-variant'}}</v-icon>
              </v-btn>
              </template>
              <div style="background: white; background-color: white;">

                <v-select
                  @change="onChange()" 
                  outlined
                  hide-details
                  style="padding: 16px; " 
                  v-model="selectedWBStatusId" 
                  :items="waybillStatuses" 
                  label="Waybill Status"
                  item-text="StatusName" 
                  item-value="StatusId"></v-select> 

                  <v-select 
                      @change="onChange()" 
                      outlined
                      hide-details 
                      style="padding: 16px;" 
                      v-if="this.user.roleId == 1" 
                      v-model="selectedFFId" 
                      :items="freightForwarders" 
                      label="Freight Forwarder"
                      item-text="userFullName" 
                      item-value="id"></v-select>

            </div>
          </v-menu>

          <div class="d-flex flex-column" v-if="(entity_name == 'wayBill' || entity_name == 'pending_wayBill') && showCardView == true">
          <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text depressed readonly v-bind="attrs" v-on="on">
                <div style="color: #808080;">{{fromDate == null ? "FROM" : fromDate}} </div>
                <div style="color: #808080;"> - </div>
                <div style="color: #808080;">  {{toDate == null ? "TO DATE" : toDate}}</div>
              </v-btn>
            </template>
            <div style="background:white">
              <v-date-picker v-model="fromDate" label="From Date" @input="handleDateChange"></v-date-picker>
              <v-date-picker v-model="toDate" label="To Date" @input="handleDateChange"></v-date-picker>
              <div style="padding: 8px;">
          <v-btn color="red" outlined
            @click="clearDateFilter()">Clear Filter</v-btn></div>
            </div>
            
          </v-menu>

          </div>

          <v-btn v-if="entity_name == 'wayBill' || entity_name == 'pending_wayBill' || entity_name == 'driver' || entity_name == 'truck' " text color="transparent">
            <div style="color: #808080;">DISPLAYING・</div>
            <div style="color: #4A4A4A;">{{ paginatedList.length }} / {{ items.length }} </div>
            <div style="color: #808080;">・TOTAL</div>
          </v-btn>

        </v-row>
        <v-col class="d-flex flex-row-reverse align-center">
          <v-btn v-if="(hideAddButton === undefined || hideAddButton == false)" depressed dark color="green"
            @click="addItem()">
            <v-icon color="white" dark>mdi-plus</v-icon>
          </v-btn>
          <v-btn text depressed color="green" class="mr-2" :disabled="loading" @click="getItems()">
            <v-icon left dark>mdi-refresh</v-icon>
            {{ reloadText }} 
          </v-btn>
          <v-btn text depressed color="green" class="mr-2" @click="ClearAllClicked()" :disabled="clearClicked"
            v-if="(show_clear !== undefined && show_clear === true && items.length > 0)">
            Clear All
          </v-btn>
          <v-btn icon  class="" @click="GeneratePDFFile()" :disabled="printClicked"
            v-if="(show_print !== undefined && show_print === true)">
            <v-icon color="black" dark>print</v-icon>
          </v-btn>
          <v-btn  icon class="" @click="GenerateExcelFile()" :disabled="excelClicked"
            v-if="(show_excel !== undefined && show_excel === true)">
            <v-icon color="black" dark>mdi-file-excel-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="6">
          <span>{{ title }}</span>
        </v-col>
        <v-col class="d-flex flex-row-reverse"
          v-if="(show_clear !== undefined && show_clear === true && items.length > 0)">
          <v-btn :disabled="clearClicked" color="primary" @click="ClearAllClicked()">Clear All</v-btn>
        </v-col>
        <v-col class="d-flex flex-row-reverse" v-if="(show_excel !== undefined && show_excel === true)">
          <v-btn :disabled="excelClicked" color="primary" @click="GenerateExcelFile()">Excel</v-btn>
        </v-col>
        <v-col class="d-flex flex-row-reverse" v-if="(show_print !== undefined && show_print === true)">
          <v-btn :disabled="printClicked" color="primary" @click="GeneratePDFFile()">Print</v-btn>
        </v-col>
        <v-col class="d-flex flex-row-reverse">
          <v-btn color="primary" @click="ViewAllClicked()">View All</v-btn>
        </v-col>
      </v-row>
    </v-card-title>

    <v-row style="width: fit-content;" no-gutters>
    <!-- <v-select 
    @change="onChange()" 
    outlined
    hide-details 
    style="width: 20%; display: inline-block; padding: 16px;" 
    v-if="this.user.roleId == 1 && (entity_name == 'wayBill' || entity_name == 'pending_wayBill')" 
    v-model="selectedFFId" 
    :items="freightForwarders" 
    label="Freight Forwarder"
    item-text="userFullName" 
    item-value="id"></v-select> -->

    <!-- <v-select
    @change="onChange()" 
    outlined
    hide-details
    style="width: 20%; display: inline-block;  padding: 16px; " 
    v-if="entity_name == 'wayBill' || entity_name == 'pending_wayBill'" 
    v-model="selectedWBStatusId" 
    :items="waybillStatuses" 
    label="Waybill Status"
    item-text="StatusName" 
    item-value="StatusId"></v-select>  -->
  </v-row>


    <v-data-table id="table"
    v-bind:style="((entity_name === 'wayBill' || entity_name === 'truck' || entity_name === 'driver') && showCardView == true)? 'display:none;' : 'display:block;'"
      :headers="headers.filter(h => h.hide_in_table === undefined && (user.roleId === 1 || h.hide_client === undefined))"
      :items="items" :search="search" :loading="loading" v-if="!reload" multi-sort :page.sync="pageNumber" :items-per-page.sync="perPage"
      @click:row="row => rowClick(row)">
      <template v-for="(field, i) in allHeaders" v-slot:[getFieldName(field)]="{ item }">
        <div :key="i">
          <slot :name="getFieldName(field)" v-bind:item="item">
            {{ item[field.value] }}
          </slot>
        </div>
      </template>
      <template v-slot:item.packages="{ item }">
        <v-chip v-for="(pack, index) in item.packages" :key="`pkg_${index}`" color="blue" dark> {{ pack.identifier !==
          undefined ? pack.identifier : "" }}</v-chip>
      </template>
      <template v-slot:item.drivers="{ item }">
        <v-chip v-for="(driver, index) in item.drivers" :key="`drv_${index}`" color="green" dark> {{ driver !== undefined
          && driver !== null ? driver.email : "" }}</v-chip>
      </template>
      <template v-slot:item.driver="{ item }">
        <v-chip color="green" dark> {{ item.driver !== undefined && item.driver !== null ? item.driver.email : ""
        }}</v-chip>
      </template>

      <template v-slot:item.freightForwarder="{ item }">
        <v-chip v-if="item.freightForwarder !== undefined" color="blue" dark> {{ item.freightForwarder.userFullName
        }}</v-chip>
      </template>
      <template v-slot:item.trucks="{ item }">
        <v-chip v-for="(truck, index) in item.trucks" :key="`trk_${index}`" color="orange" dark> {{ truck !== undefined &&
          truck !== null ? truck.truckIdentifier : "" }}</v-chip>
      </template>
      <template v-slot:item.deliveryAddresses="{ item }">
        <v-chip v-for="(deliveryAddress, index) in item.deliveryAddresses" :key="`client_${index}`" color="pink" dark> {{
          deliveryAddress.name }}</v-chip>
      </template>
      <template v-slot:item.user="{ item }">
        <v-chip v-if="item.user !== undefined" color="blue" dark> {{ item.user.email }}</v-chip>
      </template>
      <template v-slot:item.identifier="{ item }">
        <v-chip color="black" dark>{{ item.identifier | truncate(10, ' ... ') }}</v-chip>
      </template>

      <template v-slot:item.waybillStatus="{ item }">
        <v-chip v-if="item.waybillStatus == 'Active'" color="amber" dark>{{ item.waybillStatus }}</v-chip>
        <v-chip v-if="item.waybillStatus == 'In Progress'" color="orange" dark>{{ item.waybillStatus }}</v-chip>
        <v-chip v-if="item.waybillStatus == 'Completed'" color="green" dark>{{ item.waybillStatus }}</v-chip>
        <v-chip v-if="item.waybillStatus == 'Pending FF'" color="red" dark>{{ item.waybillStatus }}</v-chip>
        <v-chip v-if="item.waybillStatus == 'TEST'" color="blue" dark>{{ item.waybillStatus }}</v-chip>
        <v-chip v-if="item.waybillStatus == 'Pending Admin'" color="red" dark>{{ item.waybillStatus }}</v-chip>
        <v-chip v-if="item.waybillStatus == 'Rejected'" color="red" dark>{{ item.waybillStatus }}</v-chip>
      </template>

      <template v-slot:item.qrCode="{ item }">
        <v-img :src="getQrCodeMediaUrl(item)" height="50" width="50" contain></v-img>
      </template>
      <template v-slot:item.profileImage="{ item }">
        <v-img :src="getProfileImage(item)" height="100" width="100" contain></v-img>
      </template>
      <template v-slot:item.idGender="{ item }">
        {{ getGender(item.idGender) }}
      </template>
      <template v-slot:item.idBloodType="{ item }">
        {{ getBloodType(item.idBloodType) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="rowClick(item)">
          edit
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          delete
        </v-icon>
        <v-chip v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" small class="mr-2"
          @click="approveItem(item)">
          Approve
        </v-chip>
        <v-chip v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" small @click="rejectItem(item)">
          Reject
        </v-chip>
      </template>
    </v-data-table>
    <div class="text-center pt-2" v-if="paginated === true">
      <v-pagination v-model="page" :length="pageCount[entity_name]" :total-visible="15"></v-pagination>
    </div>
    
    <v-container class="pa-6" v-if="((entity_name === 'wayBill' || entity_name === 'truck' || entity_name === 'driver') && showCardView == true)">

      <v-row :key="componentKey"  class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 gap-4 justify-content-start justify-sm-center" style="gap: 20px; width: 100%;" no-gutters>

        <v-card class="generic-card col" style="max-width: 400px;" v-for="(item, i) in paginatedList" v-bind:data="item" v-bind:key="item.id" @click="rowClick(item)">
          <div v-if="item.waybillStatus !== undefined">
            <div v-if="item.waybillStatus == 'Active'" class="card-top-gradient-yellow h-25 w-100"></div>
            <div v-if="item.waybillStatus == 'In Progress'" class="card-top-gradient-yellow h-25 w-100"></div>
            <div v-if="item.waybillStatus == 'Completed'" class="card-top-gradient-green h-25 w-100"></div>
            <div v-if="item.waybillStatus == 'Pending FF'" class="card-top-gradient-red h-25 w-100"></div>
            <div v-if="item.waybillStatus == 'TEST'" class="card-top-gradient-blue h-25 w-100"></div>
            <div v-if="item.waybillStatus == undefined" class="card-top-gradient-blue h-25 w-100"></div>
            <div v-if="item.waybillStatus == 'Pending Admin'" class="card-top-gradient-red h-25 w-100"></div>
            <div v-if="item.waybillStatus == 'Rejected'" class="card-top-gradient-red h-25 w-100"></div>
          </div>

          <v-row style="gap: 6px;" class="no-gutters justify-space-between flex-nowrap pa-3">

            <v-col class="waybill-card-grid flex-nowrap ">

              <template>
                <div v-if="item.idGender !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">full name</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ item.localizations[0] != undefined ? item.localizations[0].fullName : '' }}</div>
                </div>
              </template>
              <template
                v-for="(field, j) in headers.filter(h => h.hide_in_table === undefined && (user.roleId === 1 || h.hide_client === undefined))">
                <div
                  v-if="field.value != 'user' && field.value != 'action' && field.value != 'freightForwarder' && field.value != 'packages' && field.value != 'drivers' && field.value != 'driver' && field.value != 'trucks' && field.value != 'deliveryAddresses' && field.value != 'qrCode' && field.value != 'profileImage' && field.value != 'idGender' && field.value != 'idBloodType'">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">{{ field.text }}</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">
                    {{ item[field.value] }}
                  </div>
                </div>
              </template>

              <template>
                <div v-if="item.user !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">user</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ item.user.userFullName }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.user !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">user email</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ item.user.email }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.freightForwarder !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">freight forwarder</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ item.freightForwarder.userFullName }}</div>
                </div>
              </template>
              <!-- <template>
                <div v-if="item.packages != undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">packages</div>
                  <div v-for="(pack, index) in item.packages" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2 mt-1">{{ pack.identifier }}</div>
                </div>
              </template> -->
              <template>
                <div v-if="item.drivers !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">drivers</div>

                  <div style="display: flex; flex-direction: row; flex-wrap: nowrap; max-width: 100px;">
                    <marquee v-if="item.drivers.length > 1" behavior="scroll" direction="left">
                      <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                        <p v-for="(driver, index) in item.drivers" :key="`pkg_${index}`"
                          class="font-weight-regular text-subtitle-2 mt-1">{{ driver.email}}
                          <span v-if="index+1 != (item.drivers.length) && driver.email !== undefined">・</span></p>
                      </div>
                    </marquee>

                    <div v-if="item.drivers.length === 1">
                      <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                        <p v-for="(driver, index) in item.drivers" :key="`pkg_${index}`"
                          class="font-weight-regular text-subtitle-2 mt-1">{{ driver.email}}
                          <span v-if="index+1 != (item.drivers.length) && driver.email !== undefined">・</span></p>
                      </div>
                    </div>
                  </div>

                  <!-- <div v-for="(driver, index) in item.drivers" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2 mt-1">{{ driver.email }}</div> -->

                </div>
              </template>
              <template>
                <div v-if="item.driver !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">driver</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ item.driver.email }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.trucks !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">trucks</div>
                  <!-- <div v-for="(truck, index) in item.trucks" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2 mt-1">{{ truck.truckIdentifier }}</div> -->

                  <div style="display: flex; flex-direction: row; flex-wrap: nowrap; max-width: 100px;">
                    <marquee v-if="item.trucks.length > 1" behavior="scroll" direction="left">
                      <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                        <p v-for="(truck, index) in item.trucks" :key="`pkg_${index}`"
                          class="font-weight-regular text-subtitle-2 mt-1">{{ truck.truckIdentifier}}
                          <span v-if="index+1 != (item.trucks.length) && truck.truckIdentifier !== undefined">・</span></p>
                      </div>
                    </marquee>

                    <div v-if="item.trucks.length === 1">
                      <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                        <p v-for="(truck, index) in item.trucks" :key="`pkg_${index}`"
                          class="font-weight-regular text-subtitle-2 mt-1">{{ truck.truckIdentifier}}
                          </p>
                      </div>
                    </div>

                  </div>

                </div>
              </template>

              <template>
                <div v-if="item.qrCode !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">qr code or bar code</div>
                  <v-img :src="getQrCodeMediaUrl(item)" height="50" width="50" contain></v-img>
                </div>
              </template>
              <template>
                <div v-if="item.idGender !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">gender</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ getGender(item.idGender) }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.idBloodType !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">blood type</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ getBloodType(item.idBloodType) }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.medias != undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1 ">profile image</div>
                  <v-img :src="getProfileImage(item)" class="rounded-circle" height="100" width="100" cover></v-img>
                </div>
              </template>

            </v-col>
            <div style="max-width: fit-content; display: flex; flex-direction: column;" class=" no-gutters">
              <v-icon v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" color="green" medium @click="approveItem(item)">
                mdi-check
              </v-icon>
              <v-icon v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" color="red" medium @click="rejectItem(item)">
                mdi-close
              </v-icon>
              <v-icon color="red" medium @click="deleteItem(item)">
                mdi-delete-outline
              </v-icon>
              <!-- <v-chip v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" small class="mr-2"
                @click="approveItem(item)">
                Approve
              </v-chip>
              <v-chip v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" small @click="rejectItem(item)">
                Reject
              </v-chip> -->
            </div>



          </v-row>

          <template>
                <div style="padding:0px 12px 12px 12px;" v-if="item.deliveryAddresses !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">delivery stations</div>

                  <!-- <div v-for="(deliveryAddress, index) in item.deliveryAddresses" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2 mt-1">{{ deliveryAddress.name }}</div> -->

                  <div style="display: flex; flex-direction: row; flex-wrap: nowrap; max-width: 100%;">
                    <marquee v-if="item.deliveryAddresses.length > 1" behavior="scroll" direction="left">
                      <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                        <p v-for="(deliveryAddress, index) in item.deliveryAddresses" v-if="deliveryAddress.name !== undefined" :key="`pkg_${index}`"
                          class="font-weight-regular text-subtitle-2 mt-1">{{ deliveryAddress.name}}    
                          <span v-if="index+1 != (item.deliveryAddresses.length) && deliveryAddress.name !== undefined">・</span></p>
                      </div>
                    </marquee>
                    <div v-if="item.deliveryAddresses.length === 1">
                      <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                        <p v-for="(deliveryAddress, index) in item.deliveryAddresses" v-if="deliveryAddress.name !== undefined" :key="`pkg_${index}`"
                          class="font-weight-regular text-subtitle-2 mt-1">{{ deliveryAddress.name}}    
                          <span v-if="index+1 != (item.deliveryAddresses.length) && deliveryAddress.name !== undefined">・</span></p>
                      </div>
                    </div>
                  </div>

                </div>
              </template>

          <!-- <v-card-actions>
      <v-btn variant="text" color="deep-purple-accent-4"> Learn More </v-btn>

    </v-card-actions> -->
        </v-card>

      </v-row>

      <v-pagination class="pagination mb-2 mt-6" v-model="pageNumber" :length="pages" @input="updatePage"></v-pagination>

    </v-container>


  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MediaMixin from '../mixins/media';
import StaticMixin from '../mixins/static';
import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      excelClicked: false,
      printClicked: false,
      clearClicked: false,
      dates: ['2018-09-15', '2018-09-20'],
      menu: false,
      search: '',
      reloadText: 'Reload',
      reload: false,
      delete_click: false,
      page: 1,
      pageNumber: 1,
      perPage: 12,
      search: "",
      selectedFFId: 0,
      selectedWBStatusId: 0,
      freightForwarders: [],
      waybillStatuses: [],
      untouchedItems: this.items,
      fromDate: null,
      toDate: null,
			listCount: 0,
      paginatedList: [],
      componentKey: 0,
    }
  },
  props: ['items', 'headers', 'hideAddButton', 'showCardView', 'allowEdit', 'entity_name', 'user_id', 'driver_id', 'localizable_fields', 'no_actions', 'paginated', 'table_only', 'title', 'show_clear', 'show_excel', 'show_print'], //the data to retrieve might belong to a user or driver
  computed: {
    ...mapState('entities', ['current_entity', 'entities', 'loading', 'pageCount']),
    ...mapState('users', ['user']),
    allHeaders() {
      return this.localizable_fields !== undefined ? this.localizable_fields.concat(this.headers) : this.headers;
    },
    pages() {
			let _this = this;
			if (_this.perPage == null || _this.listCount == null) return 0;
			return Math.ceil(_this.listCount / _this.perPage);
		}
  },
  mixins: [MediaMixin, StaticMixin],
  created() {
    if (this.entity_name == 'wayBill' || this.entity_name == 'pending_wayBill' || this.entity_name == 'truck' || this.entity_name == 'driver') {
      let _this = this;
      _this.initPage();
      _this.updatePage(_this.pageNumber);
    }
	},
  methods: {
    ...mapActions('entities', ['getEntities', 'saveEntity', 'deleteEntity', 'getPaginatedEntities', 'clearAllEntities', 'approvalResponse']),
    rowClick(row) {
      if (this.allowEdit === undefined || this.allowEdit == true) {
        localStorage.setItem("SelectedwaybillStatus", "");
        localStorage.setItem("UserRoleId", this.user.roleId);
        if (!this.delete_click) this.$emit('rowClick', row)
        if (row.waybillStatus != null) {
          localStorage.setItem("SelectedwaybillStatus", row.waybillStatus);
        }
      }
    },
    initPage: function () {
      if (this.items != undefined) {
        let _this = this;
        _this.listCount = _this.items.length;
        if (_this.listCount < _this.perPage) {
          _this.paginatedList = _this.items;
        } else {
          _this.paginatedList = _this.items.slice(0, _this.perPage);
        }
      }
    },
    updatePage: function (pageIndex) {
      if (this.items != undefined) {
        let _this = this;
        let _start = (pageIndex - 1) * _this.perPage;
        let _end = pageIndex * _this.perPage;
        _this.paginatedList = _this.items.slice(_start, _end);
        _this.pageNumber = pageIndex;
      }
    },
    searchItems() {
      let finalSearch = this.search.toLowerCase().trim();
      
      if (this.entity_name === "wayBill" || this.entity_name === "pending_wayBill") {
        this.paginatedList = this.items.filter(element =>
          (element.id != undefined && element.id == (finalSearch)) ||
          (element.identifier != undefined && element.identifier.toLowerCase().includes(finalSearch)) ||
          (element.waybillStatus != undefined && element.waybillStatus.toLowerCase().includes(finalSearch)) ||
          (element.estimatedStartDate != undefined && element.estimatedStartDate.includes(finalSearch)) ||
          (element.user != undefined && element.user.userFullName.toLowerCase().includes(finalSearch)) ||
          (element.freightForwarder != undefined && element.freightForwarder.userFullName.toLowerCase().includes(finalSearch)) ||
          (element.drivers != undefined &&  element.drivers.some(driver => driver.email != undefined && driver.email.toLowerCase().includes(finalSearch))) ||
          (element.trucks != undefined && element.trucks.some(truck => truck.truckIdentifier != undefined && truck.truckIdentifier.includes(finalSearch))) ||
          (element.deliveryAddresses != undefined && element.deliveryAddresses.some(deliveryAddress => deliveryAddress.name != undefined && deliveryAddress.name.toLowerCase().includes(finalSearch)))
        );
      } else if (this.entity_name === 'driver') {
        this.paginatedList = this.items.filter(element => {
          var gender = this.getGender(element.idGender)
          var bloodType = this.getBloodType(element.idBloodType)
          return ((element.email != undefined && element.email.toLowerCase().includes(finalSearch)) ||
            (element.mainPhoneNumber != undefined && element.mainPhoneNumber.includes(finalSearch)) ||
            (element.rating != undefined && element.rating == (finalSearch)) ||
            (element.dateOfBirth != undefined && element.dateOfBirth.includes(finalSearch)) ||
            (gender != undefined && gender.toLowerCase().includes(finalSearch)) ||
            (bloodType != undefined && bloodType.toLowerCase().includes(finalSearch))
          )
        }
        );
      } else if (this.entity_name === 'truck') {
        this.paginatedList = this.items.filter(element =>
          (element.truckIdentifier != undefined && element.truckIdentifier.toLowerCase().includes(finalSearch)) ||
          (element.immatriculationNumber != undefined && element.immatriculationNumber.toLowerCase().includes(finalSearch)) ||
          (element.horsePower != undefined && element.horsePower == (finalSearch)) ||
          (element.fuelConsumptionKPL != undefined && element.fuelConsumptionKPL == (finalSearch)) ||
          (element.cubicCapacity != undefined && element.cubicCapacity == (finalSearch)) ||
          (element.deliveryAddresses != undefined && element.deliveryAddresses.some(deliveryAddress => deliveryAddress.name != undefined && deliveryAddress.name.toLowerCase().includes(finalSearch)))
        );
      }
    },
    getBloodType(bIndex) {
      if (bIndex === 1) return 'A+'
      else if (bIndex === 2) return 'A-'
      else if (bIndex === 3) return 'B+'
      else if (bIndex === 4) return 'B-'
      else if (bIndex === 5) return 'AB+'
      else if (bIndex === 6) return 'AB-'
      else if (bIndex === 7) return 'O+'
      else if (bIndex === 8) return 'O-'
    },
    getGender(gIndex) {
      if (gIndex === 1) return 'Male'
      else if (gIndex === 2) return 'Female'
    },
    handleDateChange() {
      if (this.fromDate && this.toDate) {
      const fromDateTime = new Date(this.fromDate).getTime();
      const toDateTime = new Date(this.toDate).getTime();

      this.paginatedList = this.items.filter(element => {
        const itemDateTime = new Date(element.estimatedStartDate).getTime(); // Adjust the property name according to your item's date property
        return itemDateTime >= fromDateTime && itemDateTime <= toDateTime;
      });
      }
    },
    clearDateFilter() {
      this.fromDate = null;
      this.toDate = null;
      this.initPage();
      this.updatePage(this.pageNumber);
    },
    handleInput() {
      if (this.entity_name == 'wayBill' || this.entity_name == 'pending_wayBill' || this.entity_name == 'truck' || this.entity_name == 'driver') {

        if (this.search === '') {
          this.initPage();
          this.updatePage(this.pageNumber);
        } else {

          this.debouncedSearchItems();
        }
      }

    },
    onChange() {
      this.pageNumber = 1;
      localStorage.setItem('selectedFFId', this.selectedFFId);
      localStorage.setItem('selectedWBStatusId', this.selectedWBStatusId);

      this.getEntities(this.entity_name);
    },
    reloadFreightForwarders() {
      this.waybillStatuses = [];

      this.waybillStatuses.push({
        StatusId: 0,
        StatusName: "All"
      });

      this.waybillStatuses.push({
        StatusId: 1,
        StatusName: "Active"
      });

      this.waybillStatuses.push({
        StatusId: 2,
        StatusName: "Completed"
      });

      this.waybillStatuses.push({
        StatusId: 3,
        StatusName: "Pending FF"
      });

      this.waybillStatuses.push({
        StatusId: 4,
        StatusName: "Pending Admin"
      });

      this.waybillStatuses.push({
        StatusId: 5,
        StatusName: "In Progress"
      });
      //load the trucks available to be assigned for this driver
      //var url = `/trucks/availableTrucks`
      var url = `user/getlistFF`
      axios({
        method: "GET",
        url: `${process.env.VUE_APP_baseURL}${url}`,
      }).then(response => {
        let dataobj = {
          userFullName: "All",
          id: 0
        };
        this.freightForwarder = [];
        this.freightForwarders.push(dataobj);
        this.freightForwarders.push.apply(this.freightForwarders, response.data.data)
      }).catch(error => {
        console.log(`ERRORRRRRRRRR ${error}`)
      })
    },
    getFieldName(field) {
      return 'item.' + field.value;
    },
    editItem(item) {
      console.log("editing " + item);
    },
    getItems() {
      console.log(`paginatedkhan:${this.paginated}`)
      this.fromDate = null;
      this.toDate = null;
      this.search = '';
      if (this.paginated === undefined || this.paginated === false) {
        if (this.selectedFFId != null) {
          this.getEntities(this.entity_name, this.selectedFFId);
        } else {
          this.getEntities(this.entity_name);//this.selectedFFId)
        }
      }
      else {
        var paginatedPayload = {
          name: this.entity_name,
          page: this.page,
          perPage: this.perPage,
          search: this.search
        }
        this.getPaginatedEntities(paginatedPayload)
      }
    },
    deleteItem(item) {
      this.delete_click = true;
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        this.delete_click = false;
        if (result.value) {
          item.entity_name = this.entity_name;
          this.deleteEntity(item, response => {
            this.getItems();
          })
        }
      })
    },
    approveItem(item) {
      this.delete_click = true;
      item.entity_name = this.entity_name;
      item.entity_status = 'Active';
      this.approvalResponse(item, response => {
        this.delete_click = false;
        this.getItems();
      });
    },
    rejectItem(item) {
      this.delete_click = true;
      item.entity_name = this.entity_name;
      item.entity_status = 'Rejected';
      this.approvalResponse(item, response => {
        this.delete_click = false;
        this.getItems();
      });
    },
    addItem() {
      this.current_entity[this.entity_name] = {};
      this.$emit('add');
    },
    headerContains(title) {
      for (var i = 0; i < this.headers.length; ++i) {
        var h = this.headers[i];
        if (h.value === title) return true;
      }
      return false
    },
    getGenericHeaders() {
      //return the generic headers that don't need custom rendering
    },
    getQrCodeMediaUrl(item) {
      if (item.qrCodeMedia !== undefined)
        return item.qrCodeMedia.url;
      return '';
    },
    ViewAllClicked() {
      var page = "";
      if (this.entity_name == 'notification') {
        page = "NotificationsDetailed";
      } else {
        page = this.entity_name + "s";
      }
      this.$router.push(page);
    },
    ClearAllClicked() {
      this.clearClicked = true;
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, clear all!'
      }).then((result) => {
        this.delete_click = false;
        if (result.value) {
          this.items = [];
          var name = this.entity_name;
          if (name.includes("pending_")) {
            var name_arr = name.split('_');
            var name = name_arr[1];
          }
          var url = name + `/clearAll`;
          axios({
            method: "POST",
            url: `${process.env.VUE_APP_baseURL}${url}`,
          }).then(response => {
            this.clearClicked = false;
            this.getItems();
          }).catch(error => {
            console.log(`ERRORRRRRRRRR ${error}`);
            this.clearClicked = false;
          });
          this.pageCount[this.entity_name] = 0;
        }
      })
    },
    GenerateExcelFile() {
      this.excelClicked = true;
      const mimeType = 'data:application/vnd.ms-excel';
      const tbl = document.getElementById('table');
      const wrapper = tbl.querySelector('.v-data-table__wrapper');
      const clonedTable = wrapper.cloneNode(true);
      const documentPrefix = (this.title != undefined && this.title != '') ? this.title.replace(/ /g, '-') : this.entity_name;
      const d = new Date();
      const dummy = document.createElement('a');
      dummy.href = mimeType + ', ' + encodeURI(clonedTable.outerHTML);
      dummy.download = documentPrefix
        + '-' + d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        + '-' + d.getHours() + '-' + d.getMinutes() + '-' + d.getSeconds()
        + '.xls';
      document.body.appendChild(dummy);
      dummy.click();
      document.body.removeChild(dummy);
      this.excelClicked = false;
    },
    GeneratePDFFile() {
      this.printClicked = true;
      const tbl = document.getElementById('table');
      const wrapper = tbl.querySelector('.v-data-table__wrapper');
      var tds = wrapper.getElementsByTagName('td');
      var previousPadding = null;
      for (let t = 0; t < tds.length; t++) {
        const cell = tds[t];
        if (cell.className != 'text-start') {
          continue;
        }
        cell.setAttribute('style', 'padding:0px !important');
      }
      const clonedTable = wrapper.cloneNode(true);
      this.synchronizeCssStyles(wrapper, clonedTable, true);
      clonedTable.setAttribute('style', 'overflow-x:visible;background-color:white;z-index:100000');
      clonedTable.style.position = 'absolute !important';
      clonedTable.style.width = window.outerWidth + 'px';
      clonedTable.style.height = '100%';
      clonedTable.style.boxShadow = '0px 0px 0px 1px rgba(0,0,0,0.2)';
      clonedTable.style.margin = '0px auto';
      clonedTable.style.top = 0;
      clonedTable.style.bottom = 0;
      clonedTable.style.left = 0;
      clonedTable.style.right = 0;
      clonedTable.id = 'clonedTable';
      document.body.insertBefore(clonedTable, document.body.firstChild);

      for (let v = 0; v < tds.length; v++) {
        const cell = tds[v];
        if (cell.className != 'text-start') {
          continue;
        }
        cell.setAttribute('style', 'padding:0px 16px');
      }

      let win = window.open('', '');
      win.document.body.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
      win.document.body.innerHTML = clonedTable.innerHTML;
      win.print();
      win.close();
      document.getElementById('clonedTable').remove();
      this.printClicked = false;
    },
    synchronizeCssStyles(src, destination, recursively) {
      destination.style.cssText = this.getComputedStyleCssText(src);
      if (recursively) {
        const vSrcElements = src.getElementsByTagName('*');
        const vDstElements = destination.getElementsByTagName('*');
        for (var i = vSrcElements.length; i--;) {
          const vSrcElement = vSrcElements[i];
          const vDstElement = vDstElements[i];
          vDstElement.style.cssText = this.getComputedStyleCssText(vSrcElement);
        }
      }
    },
    getComputedStyleCssText(element) {
      const cssObject = window.getComputedStyle(element);
      const cssAccumulator = [];
      if (cssObject.cssText !== '') {
        return cssObject.cssText;
      }
      for (let prop in cssObject) {
        if (typeof cssObject[prop] === 'string') {
          cssAccumulator.push(prop + ' : ' + cssObject[prop]);
        }
      }
      return cssAccumulator.join('; ');
    }
  },
  mounted() {
    this.debouncedSearchItems = debounce(this.searchItems, 300); // Adjust the debounce delay as needed (in milliseconds)
    this.reload = true
    var isNotificationPage = false;
    if (this.items != null && this.items.length > 0 && this.items[0].isSignalR != undefined) {
      isNotificationPage = true;
    }
    if (!this.headerContains('action') && this.no_actions === undefined && isNotificationPage != true) {
      this.headers.push({ text: 'Actions', value: 'action', sortable: false })
    }
    //also check if should remove some field
    //start from end to beginning to keep the indexes correct

    setTimeout(h => { this.reload = false }, 50);
    this.reloadFreightForwarders();
  },
  watch: {
    loading(newValue) {
      this.reloadText = newValue ? 'Reloading...' : 'Reload'
    },
    page(newValue) {
        this.getItems()
    },
    perPage(newValue) {
        this.getItems()
    },
    items(newValue) {
      if (this.entity_name == 'wayBill' || this.entity_name == 'pending_wayBill' || this.entity_name == 'truck' || this.entity_name == 'driver') {
        this.initPage();
        this.updatePage(this.pageNumber);
      }
    }
  }
}
</script>
<style lang="css" scoped>span.v-chip.theme--dark.v-size--default {
  margin: 2px;
}</style>